<template>
	<span>
		<div @click="close(alert, true)" class="col-md-10">
			<a v-if="alert.data.status === 'added'"> Locadora {{ companyName }} <span class="text-danger bold"> ADICIONOU</span> o cliente {{ alert.data.client.document }} no Painel de Alerta! </a>
			<a v-if="alert.data.status === 'updated'"> Locadora {{ companyName }} <span class="text-danger bold">ATUALIZOU </span> o motivo do bloqueio do cliente {{ alert.data.client.document }} no Painel de Alerta! </a>
			<a v-if="alert.data.status === 'removed'"> Locadora {{ companyName }} <span class="text-success bold">REMOVEU</span> o cliente {{ alert.data.client.document }} no Painel de Alerta! </a>
			<hr>
			<span v-if="alert.data.status === 'removed'">
				Motivo: <strong> {{ alert.data.solution }} </strong> 
			</span>
			<span v-else>
				Motivo: <strong> {{ alert.data.reason }} </strong> 
			</span>
			<br>
		</div>

		<div class="col-md-1" @click="close(alert)">
			<i class="fa fa-window-close icon"></i> 
		</div>

		<div class="space-50"></div>
        <small class="pull-right">{{ alert.date | time }}</small>
	</span>
</template>

<script>
export default {
  name: 'AlertPanelNotification',
  props: {
    alert: {
      type: Object,
      required: true
    }
  },
  computed: {
    companyName () {
      if (this.alert.data.company.fantasy_name) return this.alert.data.company.fantasy_name
      if (this.alert.data.company.company_name) return this.alert.data.company.company_name
    }
  },
  methods: {
    close (alert, navigatorTo = false) {
      if (navigatorTo) {
        this.$router.push({name: 'home'})
      }
      this.$emit('decreaseNotification', alert)
    }
  }
}
</script>

<style scoped>
  a {
    color: #777777;
  }

  .icon {
    color: #189ce2;
    border-color: #168ccb;
    font-size: 1.8rem;
	margin: -5px;
  }
</style>



// WEBPACK FOOTER //
// AlertPanelNotification.vue?04e97af2